<template>
  <HeadWithLogo/>
  <div class="text-justify">
    <span class="sp-danger">اگر پلاک ماشینی جهت کشف حجاب ثبت شود، چه اتفاقی می افتد؟</span><br><br>
    <span class="bold-h">مرحله اول</span><br><br>
    <span> ثبت پلاک برای اولین مرتبه: </span><br>
    <p>
      پس از ثبت پلاک توسط شما در سامانه، در صورتی که اولین مرتبه ای است که برای صاحب ماشین ثبت تخلف کشف حجاب ثبت میگردد، عنوان (وضعیت تخلف: تذکر) در خط آخر، در قسمت ( گزارش ثبت تخلفات قبلی) در سامانه ثبت می گردد:
    </p>
    <div class="col-12 col-md-8 mx-auto">
      <div class="py-4 text-center">
        <img src="@/assets/info3.jpg" alt="img" class="img-fluid"/>
      </div>
    </div>
    <span> و پیامک زیر برای مالک خودرو ارسال می شود: </span>
    <p>
      مالک محترم خودروی شماره ........................... در خودروی شما در آدرس شهرتهران، بزرگراه امام علی ع به سمت جنوب در تاریخ ........................... عدم رعایت حقوق شهروندی (کشف حجاب) صورت گرفته است.ضمن در خواست وتاکید بر رعایت هنجارهای جامعه ضروریست بر عدم تکرار آن اهتمام ورزید.بدیهی است در صورت تکرارآن پیگیری انتظامی وقضایی اعمال خواهد شد.
    </p>
    <span class="bold-h">مرحله دوم</span><br>
    <span>  ثبت پلاک برای دومین مرتبه:  </span><br>
    <p>
      در صورتی که پس از مدتی، <span class="text-danger">کاربر</span> دیگری همان پلاک را به دلیل کشف حجاب در روز دیگری ثبت کند،
      چند ثانیه بعد از ثبت پلاک، پیامکی مبنی بر احضار صاحب ماشین به نزدیکترین مرکز امنیت اخلاقی جهت اخذ تعهد و باز شدن پرونده در نیروی انتظامی ارسال میگردد. پس از ثبت پلاک در این حالت، عنوان (وضعیت تخلف: اخطار 1) در خط آخر در قسمت( گزارش ثبت تخلفات قبلی) در سامانه ثبت می گردد:
    </p>
    <div class="col-12 col-md-8 mx-auto">
      <div class="py-4 text-center">
        <img src="@/assets/info4.jpg" alt="img" class="img-fluid"/>
      </div>
    </div>
    <span> نکته:  </span><br>
    <p>
      حال در این حالت، در صورتی که شخص به یک مرکز امنیت اخلاقی مراجعه کند، از وی تعهد گرفته میشود. حالا اگر صاحب ماشین به پلیس امنیت اخلاقی جهت ارائه تعهد مراجعه نکند، پس از مدت حدود 20 روز، وضعیت
      تخلف آن
      پلاک از حالت <span class="text-danger">اخطار1</span> به <span
        class="text-danger">اخطار2 توقیف بر اثر دیرکرد</span> تبدیل میگردد.
    </p>
    <div class="col-12 col-md-8 mx-auto">
      <div class="py-4 text-center">
        <img src="@/assets/info5.jpg" alt="img" class="img-fluid"/>
      </div>
    </div>
    <p>
      توقیف ماشین هم که وضعیتش مشخص است. یعنی به کل نیروهای انتظامی کشور اعلام میگردد، این ماشین با این پلاک در هر جایی از کشور دیده شد بایستی توقیف گردد تا مشکلش در آن اداره تا مرکزی که اعلام شده حل گردد.
    </p>
    <span class="bold-h">مرحله سوم</span><br><br>
    <span> ثبت پلاک برای سومین مرتبه:  </span><br>
    <p>
      در صورتی که پلاک مد نظر، توسط کاربر دیگری برای سومین مرتبه ثبت کشف حجاب شود، ضمن اینکه برای مالک ماشین، پرونده ای در نیروی انتظامی باز میشود، حکم توقیف ماشین به وی اعلام و توقیف به کلیه مراکز نیروی انتظامی سراسر کشور اعلام میگردد .
      <br>حال پس از آشنایی با این نرم افزار، اگر مایل به ثبت نام در این سامانه هستید، وارد صفحه بعد بشوید.
    </p>
  </div>
  <div class="row mt-3">
    <div class="col-6 text-end">
      <RouterLink to="/introThird" class="btn btn-success px-3">
        صفحه قبل
      </RouterLink>
    </div>
    <div class="col-6 text-start">
      <RouterLink to="/register" class="btn btn-success px-3">
        صفحه بعد
      </RouterLink>
    </div>
  </div>
</template>
<style>
.intro-text {
  font-family: Calibri, sans-serif;
}
</style>
<script>
import HeadWithLogo from "@/components/HeadWithLogo";

export default {
  components: {HeadWithLogo}
}
</script>
